import { useSelector } from 'react-redux';

function useOrgDateFormat() {
  const dateFormat = useSelector((state) => state.organisation.organisation.preferences?.date_format);
  return dateFormat ?? 'MM/DD/YYYY';
}

export default useOrgDateFormat;